import { render } from "./MatchCard.vue?vue&type=template&id=4ecfb0de"
import script from "./MatchCard.vue?vue&type=script&lang=js"
export * from "./MatchCard.vue?vue&type=script&lang=js"

import "./MatchCard.vue?vue&type=style&index=0&id=4ecfb0de&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__